import SocialTraffic from "app/pages/website-analysis/social-overview/socialTraffic/SocialTraffic";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOSocialOverviewContainerSI = ({ hideFooter = false }: { hideFooter?: boolean }) => {
    const getCtaLink = (params) => {
        return {
            href: proNavigator.href("accountreview_website_social_overview", params),
            target: "_self",
        };
    };
    return (
        <SocialTraffic
            getCtaLink={getCtaLink}
            hideFooter={hideFooter}
        />
    );
};
